import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TicketButtonDto, TicketUploadPayload } from '../../../../../service/dto';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-ticket-additional-comment',
	standalone: false,
	templateUrl: './ticket-additional-comment.component.html',
	styleUrl: './ticket-additional-comment.component.scss'
})
export class TicketAdditionalCommentComponent implements OnInit {
	@Input() button!: TicketButtonDto;
	@Input() payload!: TicketUploadPayload;
	form!: FormGroup;

	constructor(private modal: NzModalRef, private fb: FormBuilder) {
	}
	ngOnInit(): void {
		if (this.button.isAdditionalCommentRequired) {
			this.form = this.fb.group({
				comment: ['', [Validators.required]],
			});
		} else {
			this.form = this.fb.group({
				comment: ['', []],
			});
		}
		this.form.get('comment')!.valueChanges.subscribe(value => this.payload.additionalComment = value);
	}

	submit(): void {
		if (this.form.valid) {
			this.modal.close(true);
		}
	}

	cancel(): void {
		this.modal.close(false);
	}
}
